<template>
  <div class="card">
    <div class="body" v-if="this.authList.length > 0">
      <div class="body planned_task">
        <div class="header">
          <h2><strong>인증 목록</strong></h2>
          <!-- <div class="header-dropdown">
            <button class="btn btn-primary" type="button" @click="saveAuth" >추가</button>
          </div> -->
        </div>
        <div class="table-responsive">
          <table class="table table-hover" style="text-align: center">
            <!-- <thead> -->
            <!-- <th>#</th> -->
            <!-- <th>&nbsp;</th> -->
            <!-- <th>&nbsp;</th> -->
            <!-- </thead> -->
            <tbody>
            <tr v-for="(auth, index) in authList" :key="index">
              <!-- <td>{{ index + 1 }}</td> -->
              <td @click="sendToNextPage(index)">{{ auth.apiName }}</td>
              <td>
                <a href="javascript:void(0);" @click="sendToNextPage(index)"
                >수정</a
                >
                &nbsp;&nbsp;&nbsp;
                <a href="javascript:void(0);" @click="deleteAuth(index)"
                >삭제</a
                >
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="body" v-if="this.authList.length == 0">
      <div class="widget-user">
        <div class="wid-u-info ml-3">
          <label class="c_radio">
            <input
              name="auth"
              type="radio"
              checked=""
              value="Api Key"
              v-model="radioValue"
            />
            <span class="checkmark"></span>
            <h6><span class="ml-2">Api Key</span></h6>
          </label>
          <p class="text-muted mb-0">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;사용자에 대한 정보를
            간단히 수집하려면 API Key 를 사용
          </p>
        </div>
      </div>
      <br />
      <!--      <div class="widget-user">-->
      <!--        <div class="wid-u-info ml-3">-->
      <!--          <label class="c_radio">-->
      <!--            <input-->
      <!--              name="auth"-->
      <!--              type="radio"-->
      <!--              value="OAuth2"-->
      <!--              v-model="radioValue"-->
      <!--            />-->
      <!--            <span class="checkmark"></span>-->
      <!--            <h6><span class="ml-2">OAuth v2</span></h6>-->
      <!--          </label>-->
      <!--          <p class="text-muted mb-0">-->
      <!--            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OAuth 2를 지원한다면-->
      <!--            OAuth2 인증방식을 선택-->
      <!--          </p>-->
      <!--        </div>-->
      <!--      </div>-->

      <br />

      <div class="mb-12" style="text-align: right">
        <button type="button" class="btn btn-primary" :disabled="saveBtn" @click="saveAuth">
          저장
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import eventbus from "@/store/modules/devEventBus";

export default {
  name: 'DevelopAppAuthPage',
  props: ["menuType"],
  components: {
  },
  data() {
    return {
      view: 0,
      radioValue: "",

      authList: [],
      saveBtn : false
    }
  },
  methods: {
    sendToNextPage(value) {
      this.$store.state.devStore.title = this.authList[value].apiName;
      this.$store.state.devStore.apiCode = this.authList[value].apiCode;

      // alert(this.$store.state.devStore.apiCode)

      this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
        .then((res)=>{
          this.$store
            .dispatch("apiDetail", {result : res})
            .then(() => {
              console.log(this.$store.state.devStore.apiData);
              // console.log(this.$store.state.devStore.formsData)
              // console.log(this.$store.state.devStore.configureData)

              this.$router.push({
                name: "DevAuthSetting",
                params: {},
              });
            })
            .catch(() => alert("오류가 발생했습니다. > 인증 부분 "));

        })

    },
    saveAuth() {
      if (this.radioValue == "" || this.radioValue == null) {
        alert("선택을 해주세요.");
        return;
      }

      this.saveBtn = true;
      this.$store.state.devStore.title = this.radioValue;

      console.log(this.$store.state.devStore.appData);

      var param = {
        appCode: this.$store.state.devStore.appCode,
        apiType: this.radioValue,
        apiName: this.radioValue,
        versionCode: this.$store.state.devStore.appData.versionCode,
      };

      this.api.insertApi(param)
        .then((res) => {
          console.log("저장 : ", res);
          this.$store.state.devStore.apiCode = res.api.apiCode;

          eventbus.$emit("menuReset");

          // this.$store
          //   .dispatch("apiDetail")
          //   .then(() => {
          //       console.log(this.$store.state.devStore.apiData)
          //       // console.log(this.$store.state.devStore.formsData)
          //       // console.log(this.$store.state.devStore.configureData)
          //       this.authList = this.$store.state.devStore.apiAuth;
          //       // this.view = 1;

          //       this.$router.push({
          //         name: "DevAuthSettings",
          //         params: {
          //           menuType: "Authentication", checkType: this.radioValue

          //         },
          //       });
          //   })

          // this.$router.push({
          //   name: "DevAuthSettings",
          //   params: {
          //     menuType: "Authentication",
          //     checkType: this.radioValue,
          //     appId: this.$route.params.appId,
          //     authName: this.radioValue,
          //   },
          // });
        })
        .catch(() => alert("오류가 발생했습니다."));
    },
    deleteAuth(index) {
      if (confirm("정말 삭제하시겠습니까?")) {
        var param = {
          appCode: this.$store.state.devStore.appCode,
          apiCode: this.authList[index].apiCode,
        };

        this.api.deleteApi(param)
          .then(() => {
            alert("삭제되었습니다.");

            eventbus.$emit("menuReset");
            // this.$store.dispatch("apiSetting").then(() => {

            //   this.view = 0
            //   this.authList = this.$store.state.devStore.apiAuth;
            // });
          })
          .catch(() => alert("오류가 발생했습니다."));
      }
    },
  },
  created() {
    console.log('DevelopAppAuthPage created')
    eventbus.$on("menuSetted", () => {
      this.saveBtn = false;
      // this.view = 0
      this.authList = this.$store.state.devStore.apiAuth;
    });
    if (this.$store.state.devStore.apiAuth.length != 0) {
      this.authList = this.$store.state.devStore.apiAuth;
      // this.view = 1;
    }
  },
  mounted() {
    console.log('DevelopAppAuthPage created')
  },
  beforeDestroy() {
    console.log('DevelopAppAuthPage beforeDestroy')
  }
}
</script>

